// @flow
import * as React from "react";
import {
  Flex,
  Heading,
  Subhead,
  Box,
  Text,
  Link as RebassLink,
  Image
} from "rebass";
import styled from "styled-components";
import omit from "lodash.omit";
import Img from "react-image";

import { metaDataProps } from "../pages/index";
import FacebookButton from "./ui/FacebookButton";
// import Users from "../components/Users/Users";
import FbUsers from "../img/FB-Users.png";
import introDevices from "../img/intro-devices.png";
import miniArrow from "../img/mini-arrow.svg";

type Props = {
  siteMetadata: metaDataProps
};

const propsToOmit = ["siteMetadata"];

const Hero = (props: Props) => (
  <Box {...omit(props, propsToOmit)}>
    <div className="container">
      <Flex wrap>
        <Box w={[1, 1, 1 / 2]}>
          <StyledHeading
            is="h1"
            mt={[3, 3, "180px"]}
            mb={[3, 3, 3]}
            className="text-center text-left-desktop"
            f={[4, 4, "38px"]}
            color="base"
          >
            Your automated messaging platform that converts leads into
            customers.
          </StyledHeading>

          <StyledSubhead
            is="p"
            mb={[4, 4, "48px"]}
            f={["15px", 2, 2]}
            className="text-center text-left-desktop"
            color="support1"
            w={[1, 1, "80%"]}
          >
            Pipeline sparks Messenger conversations with leads as they move
            through your sales funnel then helps convert them into customers.
          </StyledSubhead>

          <Text className="text-center text-left-desktop relative" mb={[3]}>
            <CTAminiArrow src={miniArrow} />
            <RebassLink href={props.siteMetadata.appUrl}>
              <StyledFacebookButton mb={[2, 2, 3, 4]}>
                GET STARTED FOR FREE
              </StyledFacebookButton>
            </RebassLink>

          </Text>

          <InfoText className="text-center text-left-desktop" f={[1]} mb={[5]}>
            Easy setup &#124; Cancel any time
          </InfoText>
        </Box>

        <Box w={[1, 1, 1 / 2]} mt={[0, 0, 4]}>
          <MessengerLogoBg>
            <StyledMessengerLogo>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="96 83 342 344"
              >
                <defs>
                  <filter
                    xmlns="http://www.w3.org/2000/svg"
                    id="dropshadow"
                    height="130%"
                  >
                    <feGaussianBlur in="SourceAlpha" stdDeviation="5" />
                    <feOffset dx="2" dy="9" result="offsetblur" />
                    <feComponentTransfer>
                      <feFuncA type="linear" slope="0.16" />
                    </feComponentTransfer>
                    <feMerge>
                      <feMergeNode />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>
                <path
                  d="M257 93c-89 0-161 67.2-161 150 0 47.2 23.4 89.3 60 116.8V417l54.8-30.3A172 172 0 0 0 257 393c89 0 161-67.2 161-150S346 93 257 93zm16 202l-41-44-80 44 88-94 42 44 79-44-88 94z"
                  fill="#0084ff"
                  filter="url(#dropshadow)"
                />
              </svg>
            </StyledMessengerLogo>
          </MessengerLogoBg>

          {/* <Users /> */}

          <div className="relative">
            <StyledFbUsers
              src={FbUsers}
              alt="Facebook users"
              w={["200px", "null", "270px"]}
              mt={[2]}
              mx="auto"
              is={Img}
            />

            <IntroArrow src={miniArrow} />
          </div>
        </Box>
      </Flex>

      <Flex mb={["-100px", "-130px", "-150px", "-240px"]}>
        <Box w={[1]} mx="auto">
          <StyledHeading
            is="h2"
            mt={["50px", "50px", "100px"]}
            mb={[3, 3, 3]}
            f={[4, 4, "28px"]}
            color="base"
            align="center"
          >
            Looking to convert more leads? Meet Pipeline.
          </StyledHeading>

          <StyledSubhead
            is="p"
            mb={[4, 5, 5, "48px"]}
            f={["15px", 2, 2]}
            color="support1"
            align="center"
            w={[1, 1, "80%", "50%"]}
            mx="auto"
          >
            Pipeline allows you to tie conversation automation with your sales
            funnel. Enabling you to automatically engage with leads as they show
            interest in your products.
          </StyledSubhead>

          <IntroImage src={introDevices} is={Img} />
        </Box>
      </Flex>
    </div>
  </Box>
);

export default Hero;

// Styled Components
const StyledHeading = styled(Heading)`
  color: ${p => p.theme.colors.base};
  font-family: "PT Sans", sans-serif;
  font-weight: 400;
  position: relative;
  z-index: 1;
`;

const StyledSubhead = styled(Subhead)`
  font-weight: 300;
  line-height: 1.6;
  position: relative;
  z-index: 1;
`;

const StyledFacebookButton = styled(FacebookButton)`
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  height: 56px;
  padding-top: 15px;
  position: relative;
  width: auto;
  z-index: 1;
`;

const InfoText = styled(Text)`
  color: #a8b3bb;
`;

const StyledMessengerLogo = styled.div`
  background: #ffffff;
  border-radius: 30px;
  box-shadow: -4px 4px 0 2px #ebecee, -2px -1px 49px 0 rgba(88, 95, 100, 0.04);
  margin: 0 auto;
  padding: 30px;

  /* &:hover {
    box-shadow: inset -2px 2px 2px 0 #f5f5f7,
      -2px -1px 49px 0 rgba(88, 95, 100, 0.04), inset 1px 0px 1px 1px #f5f5f7;

    svg {
      left: -2px;
      opacity: 0.86;
      position: relative;
      top: 2px;
    }
  } */

  svg {
    display: block;
    margin: 0 auto;
    max-height: 180px;
    opacity: 0.46;

    @media (min-width: 48em) {
      margin: 30px auto;
    }
  }
`;

const MessengerLogoBg = styled.div`
  background: #f8fbfd;
  border-radius: 26.4px;
  border: 1px solid rgba(151, 151, 151, 0.06);
  box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.08);
  margin: 0 auto;
  opacity: 0.9;
  padding: 30px;
  position: relative;
  transform: rotate(-13deg);
  width: 215px;
  z-index: 1;

  @media (min-width: 48em) {
    padding: 25px;
    width: 360px;
  }
`;

const StyledFbUsers = styled(Image)`
  display: block;
  position: relative;
  z-index: 1;
`;

const IntroImage = styled(Image)`
  left: 0;
  margin: 0 auto;
  max-width: 642px;
  position: relative;
  right: 0;
  /* top: -4%; */
  width: 90%;
  z-index: 2;

  /* @media (min-width: 22em) {
    top: -4%;
    width: 80%;
  }

  @media (min-width: 26em) {
    top: -5%;
  }

  @media (min-width: 30em) {
    top: -6%;
    width: 75%;
  }

  @media (min-width: 32em) {
    top: -11%;
    width: 75%;
  } */
`;

const IntroArrow = styled(Img)`
  bottom: -30px;
  left: 51%;
  margin: 0 auto;
  position: absolute;
  right: 50%;

  @media (min-width: 48em) {
    bottom: -60px;
    left: 0;
    right: 0;
    transform: rotate(18deg);
  }
`;

const CTAminiArrow = styled(Img)`
  margin-left: -13px;
  position: absolute;
  top: -18px;
  transform: rotate(-41deg);
`;



// WEBPACK FOOTER //
// ./src/components/Hero.jsx